import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import LibraryService from '../../core/service'

export const getSearchCompanyInFollowList = createAsyncThunk(
  'library/followingList/getSearchCompanyInFollowList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await LibraryService.getSearchCompanyInFollowList(params)
      if (response.success) return response
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const delUnFollow = createAsyncThunk(
  'library/followingList/delUnFollow',
  async (params, { rejectWithValue }) => {
    try {
      const response = await LibraryService.delUnFollow(params)
      if (response.success) return response.data
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getHeaderFollow = createAsyncThunk(
  'library/followingList/getHeaderFollow',
  async (params, { rejectWithValue }) => {
    try {
      const response = await LibraryService.getHeaderFollow(params)
      if (response.success) return response.data
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getAllIdFollow = createAsyncThunk(
  'library/followingList/getAllIdFollow',
  async (params, { rejectWithValue }) => {
    try {
      const response = await LibraryService.getAllIdFollow(params)
      if (response.success) return response.data
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
